import React from "react";
import { CreateProjectModalForm } from "../types";
import { Controller, useFormContext } from "react-hook-form";
import { CurrencyInput, DateInput, FormInput } from "../../../forms";
import { AdviceTypesSelect, ClientProjectStatusSelect, GenericAdviserSelect, GenericUserSelect } from "../../../forms/selects";

export const ProjectDetailsForm = ({ isDisabled } : Readonly<{ isDisabled: boolean }>) => {
    const { control, setValue, watch, formState: { errors } } = useFormContext<CreateProjectModalForm>();
    const divisionId = watch('divisionId');
    return (
        <>
            <div className="row mb-3">
                <div className="col-12">
                    <Controller
                        name="description"
                        control={control}
                        rules={{ required: 'Project description must be set.' }}
                        render={({ field: { ref, ...rest } }) => (
                            <FormInput
                                label="Description"
                                disabled={isDisabled}
                                disableAnimations={true}
                                errorAllowRetry={false}
                                errorMessage={errors?.description?.message}
                                {...rest}
                            />
                        )}
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-12">
                    <Controller
                        name="comment"
                        control={control}
                        render={({ field: { ref, ...rest } }) => (
                            <FormInput
                                label="Comment"
                                disabled={isDisabled}
                                disableAnimations={true}
                                {...rest}
                            />
                        )}
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <Controller
                        name="adviceType"
                        control={control}
                        render={({ field: { ref, value, onChange, ...rest } }) => (
                            <AdviceTypesSelect
                                label="Advice Type"
                                isDisabled={isDisabled}
                                disableAnimations={true}
                                defaultValue={value}
                                onChange={(e: any) => setValue('adviceType', e.value)}
                            />
                        )}
                    />
                </div>
                <div className="col">
                    <Controller
                        name="status"
                        control={control}
                        render={({ field: { ref, value, onChange, ...rest } }) => (
                            <ClientProjectStatusSelect
                                label="Project Status"
                                isDisabled={isDisabled}
                                disableAnimations={true}
                                defaultValue={value}
                                onChange={(e: any) => setValue('status', e.value)}
                            />
                        )}
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <Controller
                        name="targetDate"
                        control={control}
                        render={({ field: { ref, value, onChange, ...rest } }) => (
                            <DateInput
                                label="Target Date"
                                disabled={isDisabled}
                                disableAnimations={true}
                                value={value}
                                onBlur={(e: any) => setValue('targetDate', e)}
                            />
                        )}
                    />
                </div>
                <div className="col">
                    <Controller
                        name="projectValue"
                        control={control}
                        render={({ field: { ref, value, onChange, ...rest } }) => (
                            <CurrencyInput
                                label="Revenue"
                                disabled={isDisabled}
                                disableAnimations={true}
                                value={value}
                                onChange={(e: any, values: any) => setValue('projectValue', values.floatValue)}
                            />
                        )}
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <Controller
                        name="adviserId"
                        control={control}
                        rules={{ required: 'Project adviser must be set.' }}
                        render={({ field: { ref, value, onChange, ...rest } }) => (
                            <GenericAdviserSelect
                                label="Adviser"
                                isDisabled={isDisabled}
                                disableAnimations={true}
                                errorAllowRetry={false}
                                errorMessage={errors?.adviserId?.message}
                                divisionId={divisionId}
                                defaultValue={value}
                                placeholder="Adviser for the Project"
                                onChange={(e: any) => setValue('adviserId', e.value)}
                            />
                        )}
                    />
                </div>
                <div className="col">
                    <Controller
                        name="driverId"
                        control={control}
                        rules={{ required: 'Project driver must be set.' }}
                        render={({ field: { ref, value, onChange, ...rest } }) => (
                            <GenericUserSelect
                                label="Driver"
                                isDisabled={isDisabled}
                                disableAnimations={true}
                                errorAllowRetry={false}
                                errorMessage={errors?.driverId?.message}
                                divisionId={divisionId}
                                defaultValue={value}
                                placeholder="Driver for the Project"
                                onChange={(e: any) => setValue('driverId', e.value)}
                            />
                        )}
                    />
                </div>
            </div>
        </>
    );
};